// extracted by mini-css-extract-plugin
export var container_image = "Cafetera-module--container_image--c25a4";
export var container_second_nav = "Cafetera-module--container_second_nav--fe3e7";
export var main_container = "Cafetera-module--main_container--3d162";